import {gql} from '@apollo/client';

export const contactMutations = {
    CREATE_CONTACT: gql`
        mutation CreateContact($input: ContactCreateInputModelInput!) {
            createContact(input: $input) {
                id
                objectId
                objectType
                type
                value
            }
        }
    `,
    UPDATE_CONTACT: gql`
        mutation UpdateContact($input: ContactUpdateInputModelInput!) {
            updateContact(input: $input) {
                id
                objectId
                objectType
                type
                value
            }
        }
    `,

    REMOVE_CONTACTS_BY_IDS: gql`
        mutation RemoveContactsByIds($ids: [UUID!]!) {
            removeContactsByIds(ids: $ids) {
                data
                success
                message
                statusCode
            }
        }
    `,
    REMOVE_CONTACTS_BY_OBJECT_ID_AND_OBJECT_TYPE: gql`
        mutation RemoveContactsByObjectIdAndObjectType($objectId: String!, $objectType: String!) {
            removeContactsByObjectIdAndObjectType(objectId: $objectId, objectType: $objectType) {
                data
                success
                message
                statusCode
            }
        }
    `,
};
